export default (grid) => grid.map((row) => row.join('\t')).join('\n');
